import { useMemo } from "react";
import {
  Grid,
  EditButton,
  DeleteButton,
  Stack,
  CreateButton,
  Typography,
  Button,
  useDataGrid,
  DataGrid,
  List,
} from "@pankod/refine-mui";
import { itIT } from "@mui/x-data-grid";
import useLocales from "locales/useLocales";
import useAuth from "contexts/AuthContext";
import axiosInstance from "utils/axios";

export default function CompList() {
  const { currentLang, defaultLang } = useLocales();
  //const owner = JSON.parse(localStorage.getItem("user")).id;
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  const {
    dataGridProps,
    sortingMode,
    sortModel,
    onSortModelChange,
    setFilters,
  } = useDataGrid({
    resource: "strutture-ext",
    metaData: {
      locale: defaultLang,
      populate: "deep,2",
      fakeParam: currentLang.value,
    },
    permanentFilter: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
      { field: "gestore", operator: "eq", value: "false" },
    ],
  });

  const columns = useMemo(
    () => [
      { field: "businessName", headerName: "Nome", flex: 1, minWidth: 300 },
      {
        field: "address",
        headerName: "Indirizzo",
        flex: 1,
        minWidth: 300,
      },
      {
        field: "city",
        headerName: "Città",
        flex: 1,
        minWidth: 100,
      },
      {
        field: "active",
        headerName: "Attivo",
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => {
          const value = row?.active;
          return value ? "Si" : "No";
        },
      },
      {
        headerName: "Azioni",
        field: "actions",
        minWidth: 50,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton hideText recordItemId={params.row.id} />
              <DeleteButton hideText recordItemId={params.row.id} />
            </Stack>
          );
        },
      },
      {
        headerName: "gestione Economica",
        field: "stripe_id",
        minWidth: 200,
        renderCell: function render(params) {
          return (
            <Grid item xs={12} container justifyContent="space-around">
              <Grid item xs={12} container justifyContent="center">
                <Button
                  fullWidth
                  onClick={async () => {
                    let res = await axiosInstance.get(
                      "/api/account-setup?strutturaID=" + params.row.id
                    );
                    window.open(res.data, "_self");
                  }}
                  color={"success"}
                  variant="outlined"
                >
                  Gestisci Account
                </Button>
              </Grid>
            </Grid>
          );
        },
      },
    ],
    []
  );

  return (
    <List
      resource="strutture-ext"
      //createButtonProps={{ size: "small" }}
      //headerButtons={<CreateButton>Nuovo</CreateButton>}
      //headerButtonProps={{ size: "small" }}
      title={<Typography variant="h5">Strutture</Typography>}
    >
      <DataGrid
        {...dataGridProps}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        autoHeight
      />
    </List>
  );
}
